module.exports = __webpack_public_path__ + "static/media/simfoni_transparent_icon.fed4bf39.png";